/**
 * Transforms price into common Swisscom format
 * @param price string or number
 */
export function transformPrice(price: number | string): string | undefined {
  if (price === undefined || price === null) {
    return undefined;
  }

  const priceAsNumber: number =
    typeof price === "string" ? parseFloat(price) : price;
  if (priceAsNumber % 1 === 0) {
    return priceAsNumber + ".\u2013";
  }
  return priceAsNumber.toFixed(2);
}
